<template>
  <div class="footer__bottom">
    <FooterCertificates />
    <p class="footer__copyright-text">
      &copy;&nbsp;Infermedica {{ currentYear }}. All rights reserved.
    </p>
  </div>
</template>

<script setup lang="ts">
const currentYear = computed(() => new Date().getFullYear())
</script>

<style lang="scss" scoped>
.footer {
  &__bottom {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 40px;
    width: 100%;
    padding-top: 40px;
    border-top: 1px solid var(--paper-300);

    @media (min-width: $breakpoint-lg) {
      gap: 12px;
    }
  }

  &__copyright-text {
    @include paragraph-xs;

    margin: 0;
    width: 100%;
    color: var(--color-text);
    text-align: right;
  }
}
</style>
